import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-459e6e63"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "product__preview-image" }
const _hoisted_3 = {
  key: 0,
  class: "product__cooking-time-info"
}
const _hoisted_4 = {
  key: 1,
  class: "product__cart-count"
}
const _hoisted_5 = {
  key: 2,
  class: "unavailable-block"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "unavailable-block__title" }, " Временное ограничение ", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "unavailable-block__description" }, " блюдо скоро появится ", -1))
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = { class: "product__description" }
const _hoisted_10 = { class: "product__prices" }
const _hoisted_11 = { class: "current-price rouble-symbol" }
const _hoisted_12 = {
  key: 1,
  class: "old-price rouble-symbol"
}
const _hoisted_13 = { class: "stocks" }
const _hoisted_14 = {
  key: 0,
  class: "stocks__is-new"
}
const _hoisted_15 = {
  key: 1,
  class: "stocks__discount"
}
const _hoisted_16 = { class: "hover-visible-block" }
const _hoisted_17 = {
  key: 0,
  class: "button-preloader"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FavoriteToggler = _resolveComponent("FavoriteToggler")!
  const _component_VerticalQuantityControl = _resolveComponent("VerticalQuantityControl")!
  const _component_FinalPricePanel = _resolveComponent("FinalPricePanel")!
  const _component_OptionsList = _resolveComponent("OptionsList")!
  const _component_MoPreloader = _resolveComponent("MoPreloader")!
  const _component_ProductButton = _resolveComponent("ProductButton")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_ctx.selectedOption)
    ? _withDirectives((_openBlock(), _createElementBlock("div", {
        key: 0,
        id: `product-${_ctx.product.id}`,
        ref: "productField",
        class: _normalizeClass([
      'product',
      {'product--unavailable': !_ctx.selectedOption.isAvailableForPurchase },
      {'product--selected': _ctx.isSelected },
    ])
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "image",
            style: _normalizeStyle({ backgroundImage: `url(${_ctx.product.image})`}),
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clickProduct && _ctx.clickProduct(...args)))
          }, null, 4),
          _createVNode(_component_FavoriteToggler, {
            class: "product__favorite-toggler",
            "is-favorite": _ctx.favoriteStore.favoriteProductsIds[_ctx.product.id],
            onToggle: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('toggleFavorite')))
          }, null, 8, ["is-favorite"]),
          (_ctx.selectedOption.cookingTime)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, " Предзаказ "))
            : _createCommentVNode("", true),
          (_ctx.quantityInCart)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_component_VerticalQuantityControl, {
                  quantity: _ctx.quantityInCart,
                  "is-loading": _ctx.orderStore.isLoaderVisible,
                  onIncrease: _cache[2] || (_cache[2] = ($event: any) => {_ctx.$emit('increaseQuantity', _ctx.selectedOption);}),
                  onDecrease: _cache[3] || (_cache[3] = ($event: any) => {_ctx.$emit('decreaseQuantity', _ctx.selectedOption);})
                }, null, 8, ["quantity", "is-loading"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: "product__fast-view",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('toggleFastView', _ctx.selectedOption)))
          }, " Быстрый просмотр "),
          (!_ctx.selectedOption.isAvailableForPurchase)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_8))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["product__info", {'product__info--with-options': !_ctx.isSingleOption}])
        }, [
          _createElementVNode("div", {
            class: "product__name",
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.clickProduct && _ctx.clickProduct(...args)))
          }, _toDisplayString(_ctx.product.name), 1),
          _createElementVNode("div", _hoisted_9, [
            (_ctx.isSingleOption && _ctx.selectedOption.weight)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(_ctx.selectedOption.weight) + " г ", 1)
                ], 64))
              : _createCommentVNode("", true),
            (
            _ctx.isSingleOption &&
              _ctx.selectedOption.weight &&
              _ctx.selectedOption.description
          )
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(" - ")
                ], 64))
              : _createCommentVNode("", true),
            (_ctx.selectedOption.description)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _createTextVNode(_toDisplayString(_ctx.$filters.replacedHtmlTags(_ctx.selectedOption.description)), 1)
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$filters.formattedNumber(_ctx.selectedOption.price)), 1),
            (_ctx.selectedOption.hasStopPrice)
              ? (_openBlock(), _createBlock(_component_FinalPricePanel, {
                  key: 0,
                  class: "final-price",
                  "is-reverse-panel": _ctx.isReverseFinalPanel
                }, null, 8, ["is-reverse-panel"]))
              : _createCommentVNode("", true),
            (_ctx.selectedOption.price !== _ctx.selectedOption.priceWithoutDiscount)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.$filters.formattedNumber(_ctx.selectedOption.priceWithoutDiscount)), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_13, [
              (_ctx.product.isNew)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14))
                : (_ctx.selectedOption.discountPercent)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(_ctx.selectedOption.discountPercent), 1))
                  : _createCommentVNode("", true)
            ])
          ])
        ], 2),
        _createElementVNode("div", _hoisted_16, [
          (!_ctx.isSingleOption)
            ? (_openBlock(), _createBlock(_component_OptionsList, {
                key: 0,
                class: "product__options",
                options: _ctx.product.productOptions,
                "product-id": _ctx.product.id,
                "selected-option-id": _ctx.selectedOption.id,
                onSelect: _cache[6] || (_cache[6] = (item) => _ctx.selectOption(item))
              }, null, 8, ["options", "product-id", "selected-option-id"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: _normalizeClass(["product__quantity-control", {'product__quantity-control--with-options': !_ctx.isSingleOption}])
          }, [
            (_ctx.orderStore.isLoaderVisible)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createVNode(_component_MoPreloader, { "is-multiple": true })
                ]))
              : (_openBlock(), _createBlock(_component_ProductButton, {
                  key: 1,
                  "is-in-cart": !!_ctx.quantityInCart,
                  onAdd: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('addToOrder', _ctx.selectedOption))),
                  onIncrease: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('increaseQuantity', _ctx.selectedOption))),
                  onDecrease: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('decreaseQuantity', _ctx.selectedOption)))
                }, null, 8, ["is-in-cart"]))
          ], 2)
        ])
      ], 10, _hoisted_1)), [
        [_directive_click_outside, _ctx.unselect]
      ])
    : _createCommentVNode("", true)
}